import type { Bonus, CollageItem, ComparisonRow, FaqItem, Printable, Step, Testimonial, UseCaseGroup, ValueNumber } from '../types/content'

export const productName = 'Gospel Sharing Mega Bundle'
export const checkoutUrl = 'https://the-gospel-sharing-kit.impultienda.ar/checkout'
export const offerAnchor = '#offer'

/** Finished main product mockup — used once, in the hero. */
export const heroMockup = 'https://cdn.magicpatterns.com/uploads/7CjxzBDgBYfZZgEnrxtsv3/Coleccion_Mega_Evangelio_para_Compartir.png'

/** Real printables used in the final offer collage. */
export const collagePrintables: CollageItem[] = [
  { src: 'https://cdn.magicpatterns.com/uploads/ntaKAtoqbqdciapmGtrWpd/Captura_de_pantalla_2026-10-01_101655.png', alt: 'Watercolor roses card with Romans 10:13' },
  { src: 'https://cdn.magicpatterns.com/uploads/bzdhvDa8EmftVLKUM3w9j7/Captura_de_pantalla_2026-10-01_104603.png', alt: 'Blue butterfly card with 1 John 4:10' },
  { src: 'https://cdn.magicpatterns.com/uploads/xwCeiSA3Pzg9vqLdzEr1TT/Captura_de_pantalla_2026-10-01_101612.png', alt: 'God Has a Message for You card with John 6:37' },
  { src: 'https://cdn.magicpatterns.com/uploads/jAKdNV2DNkuHubQ2J68sNX/Captura_de_pantalla_2026-10-01_101633.png', alt: 'Jesus holding the world card with Jeremiah 31:3' },
  { src: 'https://cdn.magicpatterns.com/uploads/gkS7aRXwDmdUh6h7MM6Kt1/Captura_de_pantalla_2026-10-01_104714.png', alt: 'Blue Bible card with Psalm 18' },
  { src: 'https://cdn.magicpatterns.com/uploads/syHCa192HNoiVTwMQGsCQ5/Captura_de_pantalla_2026-10-01_104641.png', alt: 'Praying hands card with Philippians 4:6' },
  { src: 'https://cdn.magicpatterns.com/uploads/hLKe6dVbQH9TBjVRuLnvuz/Captura_de_pantalla_2026-10-01_101516.png', alt: 'Watercolor lamb card with Psalm 23:3' },
  { src: 'https://cdn.magicpatterns.com/uploads/rJQXUMn1yCFV8gNhFR7vUZ/Captura_de_pantalla_2026-10-01_104917.png', alt: 'Jesus card with John 3:16' },
  { src: 'https://cdn.magicpatterns.com/uploads/7ahiHGS4wgvEsYByb6xSA6/Captura_de_pantalla_2026-10-01_104816.png', alt: 'Red roses card with Isaiah 45:22' },
]

export const printables: Printable[] = [
  {
    id: 'butterfly',
    src: 'https://cdn.magicpatterns.com/uploads/2ZnKpKVVcSnXx5Y4tPsfzE/Captura_de_pantalla_2026-10-01_104603.png',
    alt: 'Blue butterfly card titled A Message from God for You with 1 John 4:10',
    wide: false,
  },
  {
    id: 'roses',
    src: 'https://cdn.magicpatterns.com/uploads/tr6QcnHiPCimDCVVc9oR3u/Captura_de_pantalla_2026-10-01_101655.png',
    alt: 'Watercolor roses printable card with Romans 10:13',
    wide: true,
  },
  {
    id: 'globe',
    src: 'https://cdn.magicpatterns.com/uploads/jte1FeLhWRB8XWTDytDqrD/Captura_de_pantalla_2026-10-01_101633.png',
    alt: 'Illustrated card of Jesus holding the world with Jeremiah 31:3',
    wide: false,
  },
  {
    id: 'message',
    src: 'https://cdn.magicpatterns.com/uploads/fzgK1B8Lcapeik12eyzmw5/Captura_de_pantalla_2026-10-01_101612.png',
    alt: 'God Has a Message for You card with John 6:37',
    wide: true,
  },
  {
    id: 'lamb',
    src: 'https://cdn.magicpatterns.com/uploads/qTzEBhQYweNZ62U1g4mryi/Captura_de_pantalla_2026-10-01_101516.png',
    alt: 'Watercolor lamb card with Psalm 23:3',
    wide: true,
  },
  {
    id: 'sign',
    src: 'https://cdn.magicpatterns.com/uploads/mWpwBQpPkKYQxv3Hvs6LyL/Captura_de_pantalla_2026-10-01_101438.png',
    alt: 'Road sign style card with John 3:16',
    wide: false,
  },
]

export const valueNumbers: ValueNumber[] = [
  { value: '200+', label: 'Unique Gospel printables' },
  { value: '20+', label: 'Different design styles' },
  { value: '0', label: 'Repeated messages' },
  { value: 'PDF', label: 'Ready-to-print files' },
]

export const hesitations = ['What do I even say?', 'How do I start?', 'What fits this moment?']

export const steps: Step[] = [
  { title: 'Print', text: 'Choose the Gospel message you want to share and print the PDF.' },
  { title: 'Cut', text: 'Trim along the edges to prepare your individual cards or tracts.' },
  { title: 'Share', text: 'Give it to someone who may need encouragement, hope, prayer, or the Gospel.' },
]

export const themes = [
  'God’s Love',
  'Jesus & Salvation',
  'Hope',
  'Prayer',
  'Peace',
  'Encouragement',
  'Faith',
  'Strength',
  'God’s Presence',
  'Bible Verses',
  'Church Invitation',
  'Everyday Evangelism',
]

export const useCaseGroups: UseCaseGroup[] = [
  {
    title: 'In everyday life',
    scene: 'A card tucked into a thank-you note, a meal for a neighbor, or a get-well basket.',
    items: ['Personal evangelism', 'Friends and family', 'Everyday conversations', 'Encouragement'],
  },
  {
    title: 'At your church',
    scene: 'A warm word waiting on the welcome table, ready for every new face on Sunday.',
    items: ['Visitor welcome', 'Church invitations', 'Youth ministry', 'Prayer ministry'],
  },
  {
    title: 'Out in the community',
    scene: 'A full stack for the outreach table, the neighborhood walk, or the mission trip.',
    items: ['Church outreach', 'Community events', 'Neighborhood outreach', 'Mission trips'],
  },
]

export const comparisonRows: ComparisonRow[] = [
  { without: 'Designing materials from scratch', with: 'Already designed and ready to print' },
  { without: 'Wondering which message to use', with: '200+ messages for many different moments' },
  { without: 'Starting from a blank page', with: 'Pick a style you love and go' },
  { without: 'New materials for every outreach', with: 'Print again whenever an opportunity comes up' },
]

export const flow = ['Choose', 'Print', 'Cut', 'Share']

export const printAllowed = ['Personal use', 'Church use', 'Ministry use', 'Evangelism teams', 'Outreach activities']
export const printNotAllowed = ['Resold', 'Redistributed', 'Shared digitally', 'Uploaded publicly']

export const bonuses: Bonus[] = [
  {
    number: 1,
    name: '50 Gospel Conversation Starters',
    keyIdea: 'Know What to Say',
    description: 'Simple, natural openers that help you begin a Gospel conversation without it feeling forced.',
    coverImage: 'https://cdn.magicpatterns.com/uploads/jY1ENULtbfX6p1WkWMpr1D/50_iniciadores_de_conversacion_gospel.png',
  },
  {
    number: 2,
    name: 'Short Prayer Guide After Sharing',
    keyIdea: 'Pray With Confidence',
    description: 'Short prayers for before and after you share, so every opportunity is covered in prayer.',
    coverImage: 'https://cdn.magicpatterns.com/uploads/28ZuiqdxhbyDgxeLoA9jyk/Guia_de_oracion_al_amanecer.png',
  },
  {
    number: 3,
    name: 'Church Invitation Kit',
    keyIdea: 'Invite Them to Take the Next Step',
    description: 'Printable invitations that gently connect a Gospel message with a welcome to your local church.',
    coverImage: 'https://cdn.magicpatterns.com/uploads/r9z4A2E8rHDpoQTX4N3tiq/3d406038-7340-4293-a6a1-1253bee7c13d.png',
  },
  {
    number: 4,
    name: 'Gospel Message Match Guide',
    keyIdea: 'Know Exactly What to Share',
    description: 'A quick reference for 20 real-life situations, pointing you to the message type that may fit best.',
    coverImage: 'https://cdn.magicpatterns.com/uploads/76NzgMaHmTk8ni1CZ8BH8v/Guia_de_mensajes_del_evangelio.png',
  },
  {
    number: 5,
    name: '30-Day Gospel Sharing Challenge',
    keyIdea: 'Share Jesus One Day at a Time',
    description: 'A simple daily plan that helps you put your printables to use and make sharing part of everyday life.',
    coverImage: 'https://cdn.magicpatterns.com/uploads/cF6WoDm6AChS8K46fjqF6j/Desafio_Gospel_de_30_Dias.png',
  },
]

export const mainIncludes = ['200+ unique Gospel printables', '20+ visual design styles', 'Ready-to-print PDF files']

export const finalIncludes = ['200+ Unique Gospel Printables', '20+ Design Styles', '5 Free Bonuses', 'Ready-to-Print PDFs', '7-Day Guarantee']

/** PROTOTYPE ONLY — fictional sample testimonials. Replace with real customer testimonials before publishing. */
export const testimonials: Testimonial[] = [
  {
    quote:
      'I always wanted to share my faith but froze up trying to find the right words. Now I keep a few cards in my purse, and handing one over feels natural.',
    name: 'Rachel',
    role: 'Christian Mom',
  },
  {
    quote:
      'Our welcome team used to scramble for something to give visitors. Now we print a fresh stack each week, and there’s always a message that fits.',
    name: 'David',
    role: 'Church Volunteer',
  },
  {
    quote:
      'We used the cards at our fall outreach and it saved us hours of prep. Having so many different messages meant we had something for everyone we met.',
    name: 'Angela',
    role: 'Outreach Ministry Leader',
  },
  {
    quote:
      'I leave one with a tip or tuck one into a note for a coworker. Small moments — but I feel so much more prepared to start a conversation about Jesus.',
    name: 'Marcus',
    role: 'Small Group Leader',
  },
]

export const faqs: FaqItem[] = [
  {
    question: 'What exactly do I receive?',
    answer:
      'The Gospel Sharing Mega Bundle: 200+ unique printable Gospel tracts and evangelism cards in 20+ design styles, delivered as ready-to-print PDFs — plus 5 free bonuses.',
  },
  { question: 'How many printables are included?', answer: 'More than 200, each with its own Gospel-centered message.' },
  {
    question: 'Are the designs repeated?',
    answer:
      'There are 200+ unique printable messages across 20+ visual design styles. Several messages share the same visual style, but no message is repeated.',
  },
  { question: 'What format are the files?', answer: 'Ready-to-print PDF files.' },
  {
    question: 'Can I print them more than once?',
    answer: 'Yes. You can print physical copies again and again for personal, church, and ministry use.',
  },
  {
    question: 'Can my church use them?',
    answer:
      'Yes. As the purchasing customer, you can print and use physical copies for church and ministry activities, according to the included usage terms.',
  },
  {
    question: 'Can I resell the digital files?',
    answer: 'No. The digital files may not be resold, redistributed, shared digitally, or uploaded publicly.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. It’s a digital product — nothing is shipped. You print the materials yourself, at home or at a print shop.',
  },
  {
    question: 'How do I receive the files?',
    answer: 'Access is digital. Right after your purchase, you’ll receive access to download all of your files.',
  },
  {
    question: 'Can I use these for evangelism or outreach events?',
    answer: 'Yes. They’re made for outreach events, evangelism teams, and everyday Gospel sharing.',
  },
  {
    question: 'Do I need design experience?',
    answer: 'No. Everything is already designed and ready to print. Just choose, print, cut, and share.',
  },
]
